<template>
  <div class="mx-auto container mt-20">
    <div class="inputs-section">
      <h3 class="text-2xl font-semibold">Current Maintenance Baseline</h3>
      <div class=" grid grid-cols-3 gap-4">
        <div class="field my-4 p-3">
          <div class="flex">
            <label>Annual Labor Cost ($)</label>
            <input class="input" v-model.number="form.labor_cost" type="number" step="1000"/>
          </div>
          <input class="range" v-model.number="form.labor_cost" type="range" min="0" max="500000" step="1000"/>
        </div>
        <div class="field  my-4 p-3">
          <div class="flex">
            <label>Annual Materials Cost ($)</label>
            <input class="input"  v-model.number="form.materials_cost" type="number" step="1000"/>
          </div>
          <input class="range" v-model.number="form.materials_cost" type="range" min="0" max="500000" step="1000"/>
        </div>
      </div>
      <div class="field my-4">
        <label>Annual Downtime Cost ($)</label>
        <input class="input" v-model.number="form.downtime_cost" type="number" step="5000"/>
      </div>

      <h3 class="font-semibold">Implementation Details</h3>
      <div class="flex my-4 ">
        <label>Number of Sensors (200 € / sensor)</label>
        <input class="range" v-model.number="form.sensor_count" type="range" min="0" max="5000" step="1"/>
      </div>
      <div class="flex my-4">
        <label>Current OEE (%)</label>
        <input  v-model.number="form.current_oee" type="number" min="0" max="100"/>
      </div>
      <div class="flex my-4 space-x-2">
        <label>PdM Effectiveness Ratio (1:1 to 5:1)</label>
        <input class="range" v-model.number="form.pdm_ratio" type="range" min="1" max="5" step="0.5"/>
        <span>{{ form.pdm_ratio }}:1</span>
      </div>
    </div>

    <div class="results-section">
      <div class="metric highlight space-x-2 my-4 ">
        <label class="label">Implementation Cost</label>
        <span class="value">${{ formatNum(results.implementation_cost) }}</span>
      </div>
      <div class="flex highlight  my-4 space-x-2">
        <label class="label">Projected Annual Savings</label>
        <span class="value  text-green-500" >${{ formatNum(results.projected_annual_savings) }}</span>
      </div>
      <div class="flex space-x-2  space-x-2  my-4">
        <label class="label">First-Year Net ROI</label>
        <span class="value">{{ results.year_one_roi }}%</span>
      </div>
      <div class="flex space-x-2  my-4">
        <label class="label">Payback Period</label>
        <span class="value">{{ results.payback_period_months }} Months</span>
      </div>
      <div class="flex space-x-2  my-4">
        <label class="label">Projected OEE</label>
        <span class="value">{{ results.projected_oee }}% (+{{ results.oee_increase }}%)</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        labor_cost: 180000,
        materials_cost: 90000,
        downtime_cost: 450000,
        sensor_count: 200,
        current_oee: 65,
        pdm_ratio: 3
      }
    };
  },
  computed: {
    results() {
      const labor = this.form.labor_cost || 0;
      const materials = this.form.materials_cost || 0;
      const downtime = this.form.downtime_cost || 0;
      const sensors = this.form.sensor_count || 0;
      const oee = this.form.current_oee || 0;
      const ratio = Math.max(1, Math.min(5, this.form.pdm_ratio || 3));

      const totalBaseline = labor + materials + downtime;
      const savingsPct = Math.min(0.05 + (ratio * 0.04), 0.25);
      const annualSavings = totalBaseline * savingsPct;
      const implCost = sensors * 200;

      const roi = implCost > 0 ? ((annualSavings - implCost) / implCost) * 100 : 0;
      const payback = annualSavings > 0 ? (implCost / annualSavings) * 12 : 0;

      const oeeIncrease = Math.min(3 + (ratio * 2), 15);
      const projectedOee = Math.min(oee + oeeIncrease, 100);

      return {
        implementation_cost: implCost,
        projected_annual_savings: Math.round(annualSavings),
        year_one_roi: Math.round(roi),
        payback_period_months: payback.toFixed(1),
        projected_oee: projectedOee.toFixed(1),
        oee_increase: oeeIncrease
      };
    }
  },
  methods: {
    formatNum(val) {
      return (val || 0).toLocaleString();
    }
  }
};
</script>